import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-database-2-line',
    title: '极速数据查询',
    description: '覆盖双色球、大乐透、福彩3D等主流彩种，历史数据一键检索，查询速度毫秒级响应。',
  },
  {
    icon: 'ri-notification-3-line',
    title: '开奖实时推送',
    description: '开奖后第一时间推送结果通知，不错过任何重要信息，支持微信和APP多渠道通知。',
  },
  {
    icon: 'ri-brain-line',
    title: '智能分析预测',
    description: '基于AI算法和大数据技术，提供号码走势分析和智能预测参考，辅助理性决策。',
  },
  {
    icon: 'ri-line-chart-line',
    title: '专业走势图表',
    description: '多维度可视化走势图表，冷热号分析、遗漏统计一目了然，数据洞察更直观。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '数据安全保障',
    description: '所有数据来源于官方渠道，多重校验机制确保数据准确率99.9%，信息安全有保障。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步体验',
    description: 'Web端、移动端数据实时同步，随时随地查询彩票数据，体验无缝衔接。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900">
            为什么选择彩客网
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            六大核心优势，打造专业彩票数据服务体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-200 transition-all"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-primary-100 rounded-xl group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-900">
                {feat.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            了解更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}